import i18n from '@gik/i18n';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import type InkindUserUpdate from '@gik/inkind-page/models/InkindUserUpdate';
import { ModalButtonFooter } from '@gik/ui/Modal';
import type { UIGenericDialogOptions } from '@gik/ui/UIManager';
import { UI } from '@gik/ui/UIManager';
import React from 'react';
import AddEditInkindUserUpdatesModal from '../components/AddEditInkindUserUpdatesModal/AddEditInkindUserUpdatesModal';

export type openAddEditUpdateModalProps = {
  inkindRouteId: string;
  selectedUpdate?: InkindUserUpdate;
  options?: UIGenericDialogOptions;
  onSuccess?: () => void;
};

export function openAddEditUpdateModal({
  inkindRouteId,
  selectedUpdate,
  options,
  onSuccess,
}: openAddEditUpdateModalProps) {
  return UI.dialog(
    ({ close, footerRef }) => {
      return (
        <AddEditInkindUserUpdatesModal
          buttonsPortal={footerRef}
          routeId={inkindRouteId}
          selectedUpdate={selectedUpdate}
          onClose={() => {
            close();
            onSuccess?.();
          }}
        />
      );
    },

    {
      title: i18n.t(selectedUpdate ? translationKeys.EditUpdateButtonLabel : translationKeys.AddUpdateButtonLabel),
      closable: true,
      footer: <ModalButtonFooter />,
      ...options,
    }
  );
}
